import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const CuiPage = ({
  children,
  className,
  isCentered,
  isWide,
  ...rest
}) => {
  const classes = classNames('cuiPage', className, {
    'cuiPage--centered': isCentered,
    'cuiPage--wide': isWide,
  });

  return (
    <main className={classes} {...rest}>
      {children}
    </main>
  );
};

CuiPage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isCentered: PropTypes.bool,
  isWide: PropTypes.bool,
};

CuiPage.defaultProps = {
  children: undefined,
  className: undefined,
  isCentered: false,
  isWide: false,
};



// WEBPACK FOOTER //
// ./ui/components/page/Page.js